<div class="content-register">
  <div class="register-form">
    <div *ngIf="poliza == 1">
      <div class="mb-4">
        <p class="text-medium text-secondary">
          Crea tu cuenta de <br />
          usuario
        </p>
      </div>
      <div class="mb-5 pt-2">
        <form action="" #registerForm="ngForm">
          <div class="input-field">
            <input
              ngModel
              #email="ngModel"
              type="text"
              class="form-control"
              placeholder="Correo electrónico"
              name="email"
              required
              pattern="([a-z0-9._%+-]|[A-Z0-9._%+-])+@([a-z0-9._%+-]|[A-Z0-9._%+-])+\.([a-z]|[A-Z]){2,4}$"
            />
            <small
              *ngIf="!email.valid && email.touched && email.value != ''"
              class="text-danger ml-2"
            >
              Correo no válido</small
            >
          </div>
          <div class="input-field">
            <div class="input-icon">
              <i
                *ngIf="!show"
                class="fas fa-eye-slash lock"
                (click)="switchPass()"
              ></i>
              <i
                *ngIf="show"
                class="fas fa-eye lock"
                (click)="switchPass()"
              ></i>
              <input
                [type]="show ? 'text' : 'password'"
                ngModel
                type="password"
                class="form-control"
                placeholder="Contraseña"
                #password1="ngModel"
                required
                name="password1"
                minlength="8"
              />
            </div>
            <small
              *ngIf="!password1.valid && password1.touched"
              class="ml-2 text-danger"
            >
              Mínimo 8 caracteres *</small
            >
          </div>
          <div class="input-field">
            <div class="input-icon">
              <i
                *ngIf="!show"
                class="fas fa-eye-slash lock"
                (click)="switchPass()"
              ></i>
              <i
                *ngIf="show"
                class="fas fa-eye lock"
                (click)="switchPass()"
              ></i>
              <input
                [type]="show ? 'text' : 'password'"
                ngModel
                type="password"
                class="form-control"
                placeholder="Repetir contraseña"
                #password2="ngModel"
                required
                name="password2"
                minlength="8"
                (focusout)="confirmPassword(registerForm)"
                (ngModelChange)="clearErrors(registerForm)"
              />
            </div>
            <small
              *ngIf="!password2.valid && password2.touched"
              class="ml-2 text-danger"
            >
              Mínimo 8 caracteres *
            </small>
          </div>
          <div>
            <small *ngIf="mensajeError" class="ml-2 text-danger">
              {{ mensajeError }}</small
            >
          </div>

          <div class="mt-2">
            <input
              type="checkbox"
              #checkAviso="ngModel"
              required
              name="checkAviso"
              ngModel
            />
            <a
              href="https://www.segurossura.com.mx/legales/aviso-de-privacidad/"
              target="_blank"
              style="margin-left: 5px"
              >He leído y acepto el Aviso de Privacidad</a
            >
          </div>

          <div *ngIf="errorMessage">
            <small class="ml-2 text-danger"> {{ errorMessage }}</small>
          </div>
          <div *ngIf="!waitingForApi" class="button-top mt-3 text-center">
            <button
              class="btn btn-primary"
              (click)="crearUsuario(registerForm)"
              [disabled]="!registerForm.valid || !passwordConfirm"
            >
              CREAR USUARIO
            </button>
          </div>
          <div *ngIf="waitingForApi" style="text-align: center">
            <div id="loading"></div>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="poliza == 2" class="text-medium text-secondary">
      <p>
        Hemos enviado su <br />
        información de inicio de <br />
        sesión al correo
      </p>
      <p class="text-bold mt-1 mb-1">{{ email }}</p>
      <p>
        Continúe el proceso con las <br />
        instrucciones indicadas en <br />
        dicho correo
      </p>
      <div class="button-top mt-5 text-center">
        <button class="btn btn-primary mt-1" [routerLink]="'/login'">
          FINALIZAR
        </button>
      </div>
    </div>
    <div *ngIf="poliza == 3">
      <div class="mb-4">
        <p class="text-medium text-secondary">
          Estamos a un paso de <br />
          finalizar la creación de su <br />
          cuenta de usuario
        </p>
      </div>
      <div class="mb-5 pt-2">
        <form action="">
          <div>
            <input type="text" class="form-control" placeholder="Contraseña" />
          </div>
          <div>
            <input
              type="text"
              class="form-control"
              placeholder="Confirmar contraseña"
            />
          </div>
          <div class="button-top mt-3 text-center">
            <button class="btn btn-primary mt-1" [routerLink]="'/login'">
              FINALIZAR
            </button>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="poliza == 4">
      <div class="mb-4">
        <p class="text-medium text-secondary">
          Por favor ingrese su número <br />
          de póliza para realizar la <br />
          búsqueda de su información
        </p>
      </div>
      <div class="mb-5 pt-2">
        <form action="">
          <div class="input-field">
            <input
              type="text"
              class="form-control"
              placeholder="Nombre completo del asegurado"
            />
          </div>
          <div class="input-field">
            <input type="date" class="form-control" />
          </div>
          <div class="input-field">
            <input
              type="email"
              class="form-control"
              placeholder="Correo electronico"
            />
          </div>
          <div class="button-top mt-3 text-center">
            <button class="btn btn-primary" [disabled]="true">CONTINUAR</button>
          </div>
          <div class="mt-5">
            <a href="">Regresar</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- <div class="pruebas">
  <div>
    <button type="button mr-3" (click)="prueba(1)">1</button>
  </div>
  <div>
    <button type="button mr-3" (click)="prueba(2)">2</button>
  </div>
  <div>
    <button type="button mr-3" (click)="prueba(3)">3</button>
  </div>
  <div>
    <button type="button mr-3" (click)="prueba(4)">4</button>
  </div>
</div> -->
